import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import classNames from 'classnames';
import appConfig from '../../appConfig';
import PictionJS from 'piction-js';
import SelectableComponent from '../UMOSelectableItemWrapper';
import ConditionalWrapper from '../ConditionalWrapper';
import { disableRightClick } from '../../utils/uiUtils';

function UMOThumbnail({ umo, isSelectableItem, disableContextMenu, noSensitiveOverlay, intl }) {
  let imageTag;
  let url;
  let thumbWidth = umo.data.w[0] === '0' ? 200 : umo.data.w[0];
  let thumbHeight = umo.data.h[0] === '0' ? 200 : umo.data.h[0];
  const restrictionType = umo.thumbnail._data.$.restricted;
  const isRestrictThumb = restrictionType === 'T';
  const isSensitiveThumb = restrictionType === 'A' && !noSensitiveOverlay;

  if (isRestrictThumb) url = './images/thumb/restricted.jpg';
  else if (parseInt(umo.thumbnail._data.$.tsize) !== 0) {
    url = umo.thumbnail.url;
  } else {
    thumbWidth = 200;
    thumbHeight = 200;
    switch (umo.type) {
      case 'AUDIO':
        url = './images/thumb/audio.jpg';
        break;
      case 'DOCUMENT':
        url = './images/thumb/document.jpg';
        break;
      case 'RELATIONAL':
        url = './images/thumb/relational.gif';
        break;
      case 'PHOTO':
        url = './images/thumb/image.jpg';
        break;
      case 'VIDEO':
        url = './images/thumb/video.jpg';
        break;
      default:
        url = './images/thumb/img_nothumb.gif';
        break;
    }
  }

  // for extra small thumbnails- use web Quality as thumbnail
  if (
    umo.type === 'PHOTO' &&
    appConfig.useWebQualityForSmallThumb &&
    (thumbWidth < 100 || thumbHeight < 100) &&
    umo.webQuality
  ) {
    url = umo.webQuality.url;
    thumbHeight = umo.webQuality._data.$.h || thumbHeight;
    thumbWidth = umo.webQuality._data.$.w || thumbWidth;
  }
  const thumbRatio = thumbHeight / thumbWidth;
  // if specific metatag was set to appear on img hover-
  // get from metadata list/tombstone metadata list
  const titleMetatag =
    appConfig.umoTitleMetatag &&
    ((umo.tombstoneMetadataList.getMetadata(appConfig.umoTitleMetatag) &&
      umo.tombstoneMetadataList.getMetadata(appConfig.umoTitleMetatag).value) ||
      (umo.metadataList.getMetadata(appConfig.umoTitleMetatag) &&
        umo.metadataList.getMetadata(appConfig.umoTitleMetatag).value));
  const title = titleMetatag || umo.name;

  const onImageContextMenu = disableContextMenu ? disableRightClick : undefined;
  const sensitiveDisclaimer = isSensitiveThumb && appConfig.sensitiveContentDisclaimerMessage;

  // hack to fix images with height/width ratio of more than 0.25
  // send fake ratio for justified gallery, so it creates proper image size
  // after load- fix in umoGridLayout to return image to original ratio
  const calculatedHeight = thumbRatio < 0.25 ? thumbWidth * 0.5 : thumbHeight;
  imageTag = (
    <ConditionalWrapper
      ParentWrapper={SelectableComponent}
      parentProps={{ selectableKey: umo.id }}
      condition={isSelectableItem}
    >
      <img
        alt={appConfig.umoTitleMetatag ? title : ''}
        className="image"
        src={url}
        width={thumbWidth}
        height={calculatedHeight}
        id={`selectableItem-${umo.id}`}
        onContextMenu={onImageContextMenu}
      />
    </ConditionalWrapper>
  );

  return (
    <>
      {imageTag}
      {isSensitiveThumb ? (
        <div
          className={classNames('umo-thumbnail__sensitive-overlay', {
            'umo-thumbnail__sensitive-overlay--has-disclaimer':
            Boolean(sensitiveDisclaimer),
          })}
          aria-hidden="true"
        >
          <span className="umo-thumbnail__sensitive-label">
            {intl.formatMessage({ id: 'umoThumbnail.sensitiveContentLabel' })}
          </span>
          {sensitiveDisclaimer ? (
            <span className="umo-thumbnail__sensitive-disclaimer">
              {sensitiveDisclaimer}
            </span>
          ) : null}
        </div>
      ) : null}
    </>
  );
}

UMOThumbnail.propTypes = {
  umo: PropTypes.instanceOf(PictionJS.UMO).isRequired,
  isSelectableItem: PropTypes.bool,
  disableContextMenu: PropTypes.bool,
  noSensitiveOverlay: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
};

export default injectIntl(UMOThumbnail);
